import { render, staticRenderFns } from "./channelAn.vue?vue&type=template&id=820ab3d2&scoped=true&"
import script from "./channelAn.vue?vue&type=script&lang=js&"
export * from "./channelAn.vue?vue&type=script&lang=js&"
import style0 from "./channelAn.vue?vue&type=style&index=0&id=820ab3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820ab3d2",
  null
  
)

export default component.exports